export const APP_VERSION = 'v2025.12.01.6';
